<template>
  <v-combobox
    solo
    hide-selected
    multiple
    persistent-hint
    small-chips
    :clearable="clearable"
    :disabled="disabled"
    :item-text="textField"
    :item-value="valueField"
    :value="transformedValue"
    :no-data-text="emptyText"
    @input="updateValue"
    @blur="$emit('blur')"
    :error-messages="error"
    :deletable-chips="true"
  >
  </v-combobox>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'PosCombobox',
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    label: { type: String, default: Vue.prototype.$gettext('Select ...') },
    name: { type: String, default: null },
    textField: { type: String, default: 'name' },
    valueField: { type: String, default: 'id' },
    mixerGroup: { type: Boolean, default: false },
    emptyText: { type: String, default: Vue.prototype.$gettext('No record found ...') },
    value: null,
    error: { type: Array, default: () => ([]) },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    transformedValue() {
      if(this.name == 'cookingOptions' && this.value && typeof(this.value) == 'string') {
        const list = JSON.parse(this.value);
        return list;
      }
      if (this.name == 'preferredDrink' && this.value) {
        return this.convertToArray(this.value);
      }
      return this.value;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
